import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid2";
import mw from "../../assets/images/logo/mw.png";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import Stack from "@mui/material/Stack";
import { RESET_PASSWORD_SUCCESSFULL } from "../../constants/staticText";

export default function ResetPasswordSuccessfully() {
  const handleClickOpenMedicalWisdom = () => {
    console.log("medicalWISDOM ARR Viewer");
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignSelf: "center",
        gap: 1,
      }}
    >
      <Box>
        <img
          src={mw}
          width="250"
          height="42"
          style={{
            objectFit: "cover",
            objectPosition: "left",
          }}
          alt="Medical Wisdom logo"
        />
      </Box>
      <Stack
        sx={{
          justifyContent: "center",
          alignItems: "center",
          mt: 2,
        }}
      >
        <CheckCircleOutlineIcon color="primary" style={{ fontSize: 80 }} />
      </Stack>

      <Box sx={{ py: 2 }}>
        <Typography variant="subtitle1" sx={{ padding: 0, mb: 0 }}>
          {RESET_PASSWORD_SUCCESSFULL}
        </Typography>
      </Box>

      <Button
        type="submit"
        fullWidth
        variant="contained"
        size="medium"
        sx={{ my: 1 }}
        style={{ textTransform: "none" }}
      >
        Return to Sign in
      </Button>
      <Grid
        container
        direction="row"
        sx={{
          justifyContent: "center",
          alignItems: "center",
        }}
        spacing={1}
      >
        <Grid>
          <Typography>Powered by</Typography>
        </Grid>
        <Grid>
          <Link
            component="button"
            onClick={handleClickOpenMedicalWisdom}
            variant="body2"
            underline="hover"
            sx={{
              alignSelf: "baseline",
              fontWeight: "bold",
            }}
          >
            medicalWISDOM ARR Viewer
          </Link>
        </Grid>
      </Grid>
    </Box>
  );
}
